import { Component ,HostListener} from '@angular/core';
import { Subscription } from 'rxjs';
import { IResponse } from 'src/app/interfaces/IResponse';
import { GroupService } from 'src/app/services/repositories/group.service';
import { PostService } from 'src/app/services/repositories/post.service';
import { SocialMediaService } from 'src/app/services/repositories/social-media.service';
import { UiStateService } from 'src/app/services/utilities/ui-state.service';

@Component({
  selector: 'app-instagram-stats',
  templateUrl: './instagram-stats.component.html',
  styleUrls: ['./instagram-stats.component.scss']
})
export class InstagramStatsComponent {
  data: any[] = [];
  skippedInsights:string[]=[
    "id",
    "profile_picture_url",

  ]
  private subscriptions :Subscription[]=[]
  constructor(protected postService: PostService,private groupService: GroupService,private socialMediaService:SocialMediaService,private uiStatService:UiStateService){}
  socialMedias: any[] = [];
  instagramPageIds:any[]=[]
  instagramPageNames:any[]=[]
  period={startDate:undefined,endDate:undefined}

  updateStats(dateValue:any){
    if(dateValue.endDate>new Date()){
      dateValue.endDate = new Date()
    }    
    console.log("update States on instagram",dateValue)   
    this.period = dateValue
    this.isInsightsLoading=true
    if(this.instagramPageIds.length>0){
      this.socialMediaService.getPageStatesProgress(this.instagramPageIds,this.period).subscribe((res:any)=>{
        console.log(res.data)
        this.period=res.data.period
        this.uiStatService.pageStatsupdateDateRange(this.period);
        const resObj = res.data.results?.reduce((sums:any, obj:any) => {
          for (const key in obj) {
            sums[key] = (sums[key] || 0) + (obj[key] || 0);
            sums[key]= isNaN(sums[key]) ? "--" : sums[key];
          }
          return sums;
        }, {});
        
        for(let item of this.data){
          for(let key in item){
            if(key ==="label"){
              const prop = item[key].replace("pageInsights.instagram.","")
              item.value = resObj[prop]
            }
          }
        }
        console.log(resObj)
        console.log("instagram stats", this.data)
        this.isInsightsLoading=false
      })
    }
    // console.log("end of update States",dateValue,this.period)
  }
  ngOnInit(){
    this.data = [
      {"label": "pageInsights.instagram.numberOfPublications", "value":'--',"icon":"grid","unit":"","tooltip":"pageInsights.tooltip.instagram.numberOfPublications","tooltipPosition":"tooltip-top"},
      {"label": "pageInsights.instagram.profileViews", "value":'--',"icon":"eye","unit":"","tooltip":"pageInsights.tooltip.instagram.profileViews","tooltipPosition":"tooltip-right"},
      {"label": "pageInsights.instagram.profileClicks", "value":'--',"icon":"link-click","unit":"","tooltip":"pageInsights.tooltip.instagram.profileLinkClicks","tooltipPosition":"tooltip-top"},
      {"label": "pageInsights.instagram.interactions", "value":'--',"icon":"click","unit":"","tooltip":"pageInsights.tooltip.instagram.interactions","tooltipPosition":"tooltip-top"},
      {"label": "pageInsights.instagram.accountsEngaged", "value":'--',"icon":"user-confirmed","unit":"","tooltip":"pageInsights.tooltip.instagram.accountsEngaged","tooltipPosition":"tooltip-left"},
      {"label": "pageInsights.instagram.profileLikes", "value":'--',"icon":"heart-plus","unit":"","tooltip":"tooltip.instagram.profileLikes","tooltipPosition":"tooltip-right"},
      {"label": "pageInsights.instagram.reach", "value":'--',"icon":"user-star","unit":"","tooltip":"pageInsights.tooltip.instagram.reach","tooltipPosition":"tooltip-right"},
      {"label": "pageInsights.instagram.followers", "value":'--',"icon":"user","unit":"","tooltip":"pageInsights.tooltip.instagram.followers","tooltipPosition":"tooltip-top"},
      {"label": "pageInsights.instagram.newFollows", "value":'--',"icon":"user-plus","unit":"","tooltip":"pageInsights.tooltip.instagram.newFollows","tooltipPosition":"tooltip-top"},
      {"label": "pageInsights.instagram.UnFollows", "value":'--',"icon":"user-minus","unit":"","tooltip":"pageInsights.tooltip.instagram.UnFollows","tooltipPosition":"tooltip-top"},
      {"label": "pageInsights.instagram.comments", "value":'--',"icon":"chat","unit":"","tooltip":"pageInsights.tooltip.instagram.comments","tooltipPosition":"tooltip-top"},
      {"label": "pageInsights.instagram.shares", "value":'--',"icon":"share","unit":"","tooltip":"pageInsights.tooltip.instagram.shares","tooltipPosition":"tooltip-top"},
      {"label": "pageInsights.instagram.saves", "value":'--',"icon":"bookmark","unit":"","tooltip":"pageInsights.tooltip.instagram.saves","tooltipPosition":"tooltip-top"},
      {"label": "pageInsights.instagram.totalViews", "value":'--',"icon":"eye","unit":"","tooltip":"pageInsights.tooltip.instagram.totalViews","tooltipPosition":"tooltip-right"},
      {"label": "pageInsights.instagram.postViews", "value":'--',"icon":"image-view","unit":"","tooltip":"pageInsights.tooltip.instagram.postViews","tooltipPosition":"tooltip-top"},
      {"label": "pageInsights.instagram.followerViews", "value":'--',"icon":"image-view","unit":"","tooltip":"pageInsights.tooltip.instagram.followerViews","tooltipPosition":"tooltip-top"},
      {"label": "pageInsights.instagram.nonFollowerViews", "value":'--',"icon":"image-view","unit":"","tooltip":"pageInsights.tooltip.instagram.nonFollowerViews","tooltipPosition":"tooltip-top"},
    ];
    this.subscriptions.push(
      this.postService.currentGroups.subscribe((g: number[]) => {
        if (g.length == 0)
          g = this.postService.getGroupScopesFromLocalStorage();
        
        if (g.length > 0) {
          this.groupService.getGroupByIds(g).subscribe((res: IResponse) => {
            //  this.getRecursiveSocialMediaPages(res.data);
            //  console.log('res.data', res.data);
             
              let AllGrouPages =this.getRecursiveSocialMediaPages(res.data)
              this.instagramPageIds = AllGrouPages.filter((sm:any)=>sm.source=="instagram").map((lp:any)=>lp.id);
              this.instagramPageNames =AllGrouPages.filter((sm:any)=>sm.source=="instagram").map((lp:any)=> {return {id:lp.id,name:lp.name,url:lp.url}});
              // console.log('instagramPageIds', this.instagramPageIds);
              
              this.subscriptions.push(
                this.socialMediaService.getPageStatesProgress(this.instagramPageIds,this.period).subscribe((res:any)=>{
                  console.log('res.data', res.data);
                  const resObj = res.data.results?.reduce((sums:any, obj:any) => {
                    for (const key in obj) {
                      sums[key] = (sums[key] || 0) + (obj[key] || 0);
                    }
                    return sums;
                  }, {});
                  console.log('resObj', resObj);
                  for(let item of this.data){
                    for(let key in item){
                      if(key ==="label"){
                        const prop = item[key].replace("pageInsights.instagram.","")
                        // console.log('prop', prop, resObj[prop]);
                        item.value = resObj[prop]
                      }
                    }
                  }
                  this.isInsightsLoading=false
                })
              )
          });
        }
      })
    );

  }

  getRecursiveSocialMediaPages(groups: any[]): any[] {
    groups = !Array.isArray(groups) ? [groups] : groups;
    let socialMediaPages: any[] = [];
    groups.forEach((group: any) => {
      // Add the group's social media pages if any
      if (group.socialMedia && group.socialMedia.length > 0) {
        socialMediaPages = [...socialMediaPages, ...group.socialMedia];
      }

      // Recursively add social media pages from children
      if (group.children && group.children.length > 0) {
        for (let child of group.children) {
          socialMediaPages = [
            ...socialMediaPages,
            ...this.getRecursiveSocialMediaPages(child),
          ];
        }
      }
    });
    //removing any duplicates
    const pagesArrayString: string[] = socialMediaPages.map((sm: any) =>
      JSON.stringify(sm)
    );
    const uniquePagesArrayString = [...new Set(pagesArrayString)];
    this.socialMedias = uniquePagesArrayString.map((sm: any) =>
      JSON.parse(sm)
    );
    return uniquePagesArrayString.map((sm: any) => JSON.parse(sm));
  }

  gVal(data: any){
    return data && Number(data)? Number(data): 0
  }


  // delete this part 
  isPlanned: boolean = true; 
  isPost: boolean = true; 
  isDraft: boolean = true; 
  windowWidth: number = window.innerWidth;
  isLargeView: boolean = false;
  isMediumView: boolean = false;
  isSmallView: boolean = false;
  isVerySmallView: boolean = false;
  generalInsightsLabels:string[]=[
    "pageInsights.instagram.numberOfPublications",
    "pageInsights.instagram.profileViews",
    "pageInsights.instagram.profileClicks",
    "pageInsights.instagram.accountsEngaged",
    "pageInsights.instagram.interactions",
  ]
  audienceInsightsLabels:string[]=[
    "pageInsights.instagram.reach",
    "pageInsights.instagram.followers",
    "pageInsights.instagram.newFollows",
    "pageInsights.instagram.UnFollows",
  ]
  profileInsightsLabels:string[]=[
    "pageInsights.instagram.profileLikes",
    "pageInsights.instagram.comments",
    "pageInsights.instagram.shares",
    "pageInsights.instagram.saves",
  ]

  ViewsInsightsLabels:string[]=[
    "pageInsights.instagram.totalViews",
    "pageInsights.instagram.postViews",
    "pageInsights.instagram.followerViews",
    "pageInsights.instagram.nonFollowerViews",
  ]
  isInsightsLoading:boolean=false
  
  @HostListener('window:resize', ['$event'])
  onResize() {
    this.windowWidth = window.innerWidth;

    if (1232 < this.windowWidth && this.windowWidth < 1375) {
      // Medium view
      this.isLargeView = false;
      this.isMediumView = true;
      this.isSmallView = false;
      this.isVerySmallView = false;
    } else if (1375 <= this.windowWidth && this.windowWidth < 1515) {
      // Large view
      this.isLargeView = true;
      this.isMediumView = false;
      this.isSmallView = false;
      this.isVerySmallView = false;
    } else if (this.windowWidth >= 1515) {
      // Extra large view
      this.isLargeView = false;
      this.isMediumView = false;
      this.isSmallView = false;
      this.isVerySmallView = false;
    } else if (this.windowWidth >= 1100 && this.windowWidth < 1232) {
      // Small view (windowWidth <= 1232)
      this.isLargeView = false;
      this.isMediumView = false;
      this.isSmallView = true;
      this.isVerySmallView = false;
    } else {
      this.isLargeView = false;
      this.isMediumView = false;
      this.isSmallView = false;
      this.isVerySmallView = true;
    }
  }

  togglePost() {
    this.isPost = !this.isPost;
  }
  togglePlanned() {
    this.isPlanned = !this.isPlanned;
  }
  GetGeneralData(){
    return this.data.filter((item:any)=>this.generalInsightsLabels.includes(item.label))
  }
  GetAudienceData(){
    return this.data.filter((item:any)=>this.audienceInsightsLabels.includes(item.label))
  }
  GetProfileData(){
    return this.data.filter((item:any)=>this.profileInsightsLabels.includes(item.label))
  }
  GetViewsDate(){
    return this.data.filter((item:any)=>this.ViewsInsightsLabels.includes(item.label))
  }
  // end delete
}
